import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { ApiResponse } from 'src/app/core/models/api-response';
import { IConfirmOnBoard } from '../models/confirm-on-board.model';
import { IConfirmLeave } from '../models/confirm-leave.model';
import { IPersonnelOnBoard } from '../models/current-personnel/personnel-on-board.model';
import { IPersonnelWithMissingConfirmation } from '../models/current-personnel/personnel-with-missing-confirmation.model';
import { IConfirmOnBoardMultiplePersonnel } from '../models/current-personnel/confirm-on-board-multiple-personnel.model';
import { IConfirmLeaveMultipleOnBoardPersonnel } from '../models/current-personnel/confirm-leave-multiple-on-board-personnel.model';

@Injectable({
  providedIn: 'root',
})
export class CurrentPersonnelApiService {
  headers = { 'content-type': 'application/json' };

  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/${getDepartmentId()}/plannedActivities`;
  }

  private getOnBoardUrl(departmentId = getDepartmentId()): string {
    return `${environment.apiUrl}/api/${getTenantId()}/${departmentId}/plannedActivities/onBoard`;
  }

  private get reportUrl(): string {
    return `${
      environment.apiUrl
    }/api/${getTenantId()}/${getDepartmentId()}/plannedActivities/report`;
  }

  constructor(private http: HttpClient) {}

  getAllCurrentPersonnelFromPagedUrl(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IPersonnelOnBoard[]>> {
    const url = `${this.getOnBoardUrl()}/Paged`;
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IPersonnelOnBoard[]>>(url, { params });
  }

  getAllCurrentPersonnel(departmentId = getDepartmentId()): Observable<IPersonnelOnBoard[]> {
    const url = this.getOnBoardUrl(departmentId);
    return this.http.get<IPersonnelOnBoard[]>(url);
  }

  getAllMissingConfirmationsFromPagedUrl(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IPersonnelWithMissingConfirmation[]>> {
    const url = `${this.url}/missingConfirmation/Paged`;
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IPersonnelWithMissingConfirmation[]>>(url, { params });
  }

  getAllMissingConfirmations(): Observable<IPersonnelWithMissingConfirmation[]> {
    const url = `${this.url}/missingConfirmation`;
    return this.http.get<IPersonnelWithMissingConfirmation[]>(url);
  }

  confirmOnBoard(request: IConfirmOnBoard): Observable<void> {
    const url = `${this.getOnBoardUrl()}/${request.id}/confirm`;
    return this.http.post<void>(url, request, { headers: this.headers });
  }

  confirmOnBoardMultipleUsers(request: IConfirmOnBoardMultiplePersonnel): Observable<void> {
    const url = `${this.getOnBoardUrl()}/confirm`;
    return this.http.post<void>(url, request, { headers: this.headers });
  }

  confirmLeave(request: IConfirmLeave): Observable<void> {
    const url = `${this.getOnBoardUrl()}/${request.id}/leave`;
    return this.http.post<void>(url, request, { headers: this.headers });
  }

  confirmLeaveMultipleUsers(request: IConfirmLeaveMultipleOnBoardPersonnel): Observable<void> {
    const url = `${this.getOnBoardUrl()}/leave`;
    return this.http.post<void>(url, request, { headers: this.headers });
  }

  editMultipleCurrentPersonnel(request: IConfirmOnBoardMultiplePersonnel): Observable<void> {
    const url = `${this.getOnBoardUrl()}/update`;
    return this.http.patch<void>(url, request, { headers: this.headers });
  }

  generateSafeSeaNetReport(from: Date): Observable<any> {
    const url = `${this.reportUrl}/excel/seaSafeNet`;
    return this.http.get(url, {
      params: { From: from.toISOString() },
      responseType: 'blob',
      observe: 'response',
    });
  }
}
